var components
try {
  components = {
    uCheckboxGroup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-checkbox-group/u-checkbox-group" */ "@/uni_modules/uview-ui/components/u-checkbox-group/u-checkbox-group.vue"
      )
    },
    uCheckbox: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-checkbox/u-checkbox" */ "@/uni_modules/uview-ui/components/u-checkbox/u-checkbox.vue"
      )
    },
    uRadioGroup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-radio-group/u-radio-group" */ "@/uni_modules/uview-ui/components/u-radio-group/u-radio-group.vue"
      )
    },
    uRadio: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-radio/u-radio" */ "@/uni_modules/uview-ui/components/u-radio/u-radio.vue"
      )
    },
    "u-Textarea": function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u--textarea/u--textarea" */ "@/uni_modules/uview-ui/components/u--textarea/u--textarea.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-button/u-button" */ "@/uni_modules/uview-ui/components/u-button/u-button.vue"
      )
    },
    uEmpty: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-empty/u-empty" */ "@/uni_modules/uview-ui/components/u-empty/u-empty.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-popup/u-popup" */ "@/uni_modules/uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.idList && _vm.idList.length > 0
  var l0 =
    g0 && (_vm.type == 1 || _vm.type == 2) && _vm.currentQ.questionType == 2
      ? _vm.__map(_vm.currentQ.content.items, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g1 = _vm.currentB.includes(item.prefix)
          return {
            $orig: $orig,
            g1: g1,
          }
        })
      : null
  var l1 =
    g0 && _vm.type == 3 && _vm.currentQ.questionType == 2
      ? _vm.__map(_vm.currentQ.content.items, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g2 = _vm.currentQ.answer.includes(item.prefix)
          var g3 =
            _vm.currentB.includes(item.prefix) &&
            !_vm.currentQ.answer.includes(item.prefix)
          return {
            $orig: $orig,
            g2: g2,
            g3: g3,
          }
        })
      : null
  var g4 = g0
    ? _vm.currentQ.questionType == 2 &&
      _vm.currentB.length > 0 &&
      _vm.type !== 3
    : null
  var g5 =
    g0 &&
    (((_vm.currentQ.questionType == 1 || _vm.currentQ.questionType == 3) &&
      _vm.currentA !== "") ||
      (_vm.currentQ.questionType == 2 && _vm.confirmB)) &&
    _vm.currentQ.questionType == 2
      ? _vm.currentB.join(",")
      : null
  var g6 =
    g0 &&
    (((_vm.currentQ.questionType == 1 || _vm.currentQ.questionType == 3) &&
      _vm.currentA !== "") ||
      (_vm.currentQ.questionType == 2 && _vm.confirmB)) &&
    _vm.currentQ.questionType == 2
      ? _vm.currentB.join(",")
      : null
  var g7 = _vm.idList && _vm.idList.length > 0
  var g8 = g7 ? _vm.idList.length : null
  var g9 = g7 ? _vm.idList.length : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
        l1: l1,
        g4: g4,
        g5: g5,
        g6: g6,
        g7: g7,
        g8: g8,
        g9: g9,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }